var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"fill"},[(_vm.status)?_c('el-progress',{attrs:{"percentage":_vm.percentage,"stroke-width":24,"text-inside":true,"status":_vm.status}}):_vm._e(),(!_vm.status)?_c('el-progress',{attrs:{"percentage":_vm.percentage,"stroke-width":24,"text-inside":true}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }